import PublicPage from '@/shared/PublicPage/PublicPage';
import LibraryActivitiesList from '@/pages/Library/LibraryActivities/LibraryActivitiesList/LibraryActivitiesList';
import ActivityTypesList from '@/shared/ActivityTypesList/ActivityTypesList';
import { StyledActivityIconCircle } from '@/shared/ActivityTypesList/ActivityTypesList.styled';
import ActivityTypeIcon from '@/shared/ActivityTypeIcon/ActivityTypeIcon';
import { pxToVw } from '@/modules/styled/cssUnits';
import { StyledPublicActivityType } from './PublicActivityType.styled';

export default function PublicActivityType({
  title,
  activities,
  activityType,
}) {
  return (
    <PublicPage withFooter>
      <StyledPublicActivityType>
        <LibraryActivitiesList
          title={
            <div className="title">
              <StyledActivityIconCircle
                size={16}
                width={45}
                height={45}
                type={activityType}
              >
                <ActivityTypeIcon
                  color="white"
                  size={pxToVw(15)}
                  type={activityType}
                />
              </StyledActivityIconCircle>
              <h1>{title}</h1>
            </div>
          }
          activities={activities}
          isPublic
          allowFreeLabel
          showLevelFilter
        />
        <ActivityTypesList />
      </StyledPublicActivityType>
    </PublicPage>
  );
}
